































import { Anagrafica } from "@/data/models/anagrafica.model";
import { SelectOption } from "@/data/models/select-option.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { Component, Inject, Vue } from "vue-property-decorator";
import packageInfo from "../../../package.json";

@Component
export default class CommissioneDetail extends Vue {
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;

  commissione!: SelectOption;

  loading = true;
  base!: string;
  data!: Anagrafica[];

  loadCommissione(id: number) {
    this.anagraficaService.getMenu("commissione").then((result) => {
      const elenchi: SelectOption[] = result;
      const e = elenchi.find((e: SelectOption) => e.value === id + "");
      if (e) {
        this.commissione = e;
        this.loadData(id);
      }
    });
  }

  loadData(id: number) {
    this.anagraficaService
      .getCommissione(id)
      .then((result) => {
        this.data = result;
      })
      .finally(() => (this.loading = false));
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);
  }

  mounted() {
    const albourl = this.$el.parentElement?.getAttribute("data-albo") || "";
    this.base = "/" + albourl + "?profileid=";
    const eid = this.$el.parentElement?.getAttribute("data-id");
    let id = undefined;
    if (!eid) {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      id = params.get("id");
    } else {
      id = eid;
    }
    if (id) {
      this.loadCommissione(+id);
    }
  }
}
